import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-warning w-16rem" }
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = { class: "text-sm dialog-detail" }
const _hoisted_4 = { class: "flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "caption" }
const _hoisted_6 = { class: "flex align-items-center justify-content-between text-warning mt-s2" }
const _hoisted_7 = { class: "dialog-footer dialog-footer-two-btn" }

import { setNestedDialogOpen } from '@/composables/utils/useUtils';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'LossConfirmationDialog',
  props: {
    priceImpact: null,
    totallyProvide: null,
    potentialLoss: null
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {



const { t } = useI18n();
const isDialog = ref(true);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "dismissable-mask": "",
    visible: isDialog.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((isDialog).value = $event)),
    modal: true,
    onShow: _cache[3] || (_cache[3] = ($event: any) => (_unref(setNestedDialogOpen)(true))),
    onHide: _cache[4] || (_cache[4] = ($event: any) => (_unref(setNestedDialogOpen)(false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('singleSide.lossConfirmDialog.header', { priceImpact: __props.priceImpact })), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('singleSide.lossConfirmDialog.totallyProvide')), 1),
            _createElementVNode("div", null, "≈" + _toDisplayString(__props.totallyProvide) + "$", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('singleSide.lossConfirmDialog.potentialLoss')), 1),
            _createElementVNode("div", null, "≈" + _toDisplayString(__props.potentialLoss) + "$", 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          class: "button-primary",
          label: _unref(t)('cancel'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          class: "button-base",
          label: _unref(t)('singleSide.lossConfirmDialog.confirmButtonLabel'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('confirm')))
        }, null, 8, ["label"])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})